import { render, staticRenderFns } from "./kegiatan.vue?vue&type=template&id=13db9e78&"
import script from "./kegiatan.vue?vue&type=script&lang=js&"
export * from "./kegiatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports